'use strict';

import React from 'react';
import marked from 'marked';
import {Component} from 'react';
import BfgLoanForm from './loanForm.js';
import Globalize from 'globalize';


class BfgLoanBox extends Component{

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      message: ''
    };

    this.loadLoansFromServer = this.loadLoansFromServer.bind(this);
    this.handleLoanSubmit = this.handleLoanSubmit.bind(this);

  }

  loadLoansFromServer() {
    $.ajax({
      url: this.props.url,
      dataType: 'json',
      cache: false,
      success: function(data) {
        this.setState({data: data});
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }
  handleLoanSubmit(loan) {
    var loans = this.state.data;
    loan.id = Date.now();
    var newLoans = loans.concat([loan]);
    this.setState({data: newLoans});
    $.ajax({
      url: this.props.url,
      dataType: 'json',
      type: 'POST',
      data: loan,
      success: function(data) {

        var msj = Globalize(this.props.locale).messageFormatter('loansPage/loanInfoInsertedUnsuccessful')();
        if(data) {
            var msj = Globalize(this.props.locale).messageFormatter('loansPage/loanInfoInsertedSuccessful')();
        }
        this.setState({message: msj});
      }.bind(this),
      error: function(xhr, status, err) {
        this.setState({data: loans});
        console.error(this.props.url, status, err.toString());
      }.bind(this)
    });
  }


  render() {
    return (
      <div className="bfgLoanBox">
      <BfgLoanForm onLoanSubmit={this.handleLoanSubmit} {...this.props} message={this.state.message}/>
    </div>
    );
  }
}

class LoanList extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    var loanNodes = this.props.data.map(function(loan) {
      return (
        <Loan name={loan.name} key={loan.id}>
         {loan.email}/ {loan.phone}/ {loan.address}
        </Loan>
      );
    });
    return (
      <div className="loanList">
      {loanNodes}
      </div>
    );
  }
}



class Loan extends Component{

  constructor(props) {
    super(props);
    this.rawMarkup = this.rawMarkup.bind(this);
  }
  rawMarkup() {
    var rawMarkup = marked(this.props.children.toString(), {sanitize: true});
    return { __html: rawMarkup };
  }

  render() {
    return (
      <div className="loan">
          {this.props.name}
       <span dangerouslySetInnerHTML={this.rawMarkup()} />
    </div>
    );
  }
}



module.exports = (BfgLoanBox);




// WEBPACK FOOTER //
// ./js/loanBox.js